export const CHANGE_STATE = 'CHANGE_STATE';
export const CHANGE_HEADER = 'CHANGE_HEADER';
export const CHANGE_PHONE_COUNTRY_CODE = 'CHANGE_PHONE_COUNTRY_CODE';

export const updateLoginHeader = (header) => ({
    type: CHANGE_HEADER,
    header: header,
});

export const changeLoginState = (state) => ({
    type: CHANGE_STATE,
    state: state,
});

export const changePhoneCountryCode = (countryCode) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: CHANGE_PHONE_COUNTRY_CODE,
                countryCode,
            }),
        );
    };
};
